export default __webpack_public_path__ + "8756aa723611e8ced184cb8f97a6b2e4.png";